:host {
  display: block;
}

@media screen and (max-width: 719px) {
  .pes-app-pdp__section:not(.pes-app-pdp__section--breadcrumbs) + .pes-app-pdp__section {
    margin-top: 20px;
  }
}

@media screen and (min-width: 980px) {
  .pes-app-pdp__section:not(.pes-app-pdp__section--breadcrumbs) + .pes-app-pdp__section {
    margin-top: 8px;
  }
}

@media screen and (min-width: 980px) {
  .pes-app-pdp__section--breadcrumbs {
    background-color: #ffffff;
    padding-bottom: 8px;
  }
}

.product-page-recommendations {
  display: block;
  padding: 0 16px;
}